import { Box, Text } from '@wix/design-system';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import {
  CreativeOffer,
  PurchaseOffering,
} from '@wix/premium-purchase-platform/@sdk';
import { useFoldScrollBiEvent } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import styles from './FeaturesGrid.scss';
import { FeaturesGridFeatureRow } from './FeaturesGridFeatureRow';

interface FeaturesGridGroupProps {
  group: CreativeOffer.GridNamespace;
  products?: PurchaseOffering.PurchaseProduct[];
}

export const FeaturesGridGroup = ({
  group,
  products,
}: FeaturesGridGroupProps) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const dataHook = `features-grid-fold-${group.id}`;

  useFoldScrollBiEvent({
    selector: `[data-hook="${dataHook}"]`,
    foldName: group.content?.name?.translationKey,
    pageName: 'select-plan',
    deviceType: 'desktop',
  });

  return (
    <PlatformFeaturesGrid.Content.Group
      dataHook={dataHook}
      groupHeaderClassName={styles.groupHeader}
      header={
        <Box>
          <Text weight="bold">
            {t(group.content?.name?.translationKey ?? '')}
          </Text>
        </Box>
      }
      collapsible
      labels={{
        open: t('Advanced.Plans_General_Show_features'),
        close: t('Advanced.Plans_General_Hide_features'),
      }}
      onToggle={(action) => {
        EclipsePackagePickerModule.internals.bi.onToggleFeatureGroup?.({
          groupKey: group.content?.name?.translationKey,
          action,
        });
      }}
    >
      {group.features?.map((feature) => (
        <FeaturesGridFeatureRow
          key={feature.id}
          feature={feature}
          products={products}
        />
      ))}
    </PlatformFeaturesGrid.Content.Group>
  );
};
